import classnames from "classnames";
import styles from "./iconButton.module.scss";
import Button from "@mui/material/IconButton";
import { Icon } from "ui";
import PropTypes from "prop-types";

export const IconButton = ({ children, className, icon, svg, ...props }) => {
  const { active, provider, rounded, ...rest } = props;

  if (props.hidden) return null;

  return (
    <Button
      className={classnames(styles.root, className, {
        [styles.outlined]: props.outlined,
        [styles.filled]: props.filled,
        [styles[props.color]]: props.color,
        [styles[props.size]]: props.size,
        [styles[props.variant]]: props.variant,
        [styles.disabled]: props.disabled,
        [styles.loading]: props.loading,
        [styles[provider]]: provider,
        [styles.rounded]: rounded,
        [styles.active]: active,
      })}
      {...rest}
    >
      {children ? children : <Icon name={icon} svg={svg} />}
    </Button>
  );
};

IconButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  svg: PropTypes.string,
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
};
